import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UnityConnectTransaction } from "../common/model/unity-connect-transaction";
import { SESSION_STORAGE_KEYS } from "../common/session-storage-keys";
import { NavigationService } from "../navigation.service";
import { Messages } from "../shared/messages";
import { NotificationService } from "../common/notification/notification.service";
import { BreadcrumbService } from "xng-breadcrumb";
import { Utils } from "../common/utils";
import { DocumentsService } from "../common/documents.service";
import { TransactionTypeValue } from "../common/model/unity-connect-transaction-type";
import { CirfService } from "../cirf/cirf.service";
import { ReferralService } from "../referral/referral.service";
import { SharedDocumentsPackage } from "../common/shared-documents-package";
import { MatterInfo, MatterMobileSectionTypes } from "../common/matter-info";
import { Referral } from "../referral/referral";
import { connectApi } from "../common/connect-api";
import { UnityConnectTransactionType } from "../common/model/unity-connect-transaction-type";
import { HttpClient } from "@angular/common/http";
import { DatePipe, TitleCasePipe } from "@angular/common";
import { MatterEvent } from "../common/matter-event";
import { LockScreenService } from "../common/lock-screen.service";
import { MatterWorkItem } from "../common/matter-work-item";
import * as _ from "lodash";
import { MatterDocument } from "../shared/matter-document";
import { MultipleFileUploadDialogParams } from "../common/multiple-file-upload-dialog/multiple-file-upload-dialog-params";
import { MultipleFileUploadDialogService } from "../common/multiple-file-upload-dialog/multiple-file-upload-dialog.service";
import { DocSharingMessage } from "../shared/doc-sharing-message";
import { DocSharingMessageService } from "../common/doc-sharing-message.service";
import { TABLETMIN } from "../shared/constants";
import { map } from "rxjs/operators";
import { MatterInvoice } from "../common/matter-invoice";
import { UnityConnectDocumentsTransaction } from "../common/model/unity-connect-document-transaction";

declare var jQuery: any;

@Component({
  selector: "dp-connect-matter-summary",
  templateUrl: "./matter-summary.component.html",
  providers: [TitleCasePipe],
})
export class MatterSummaryComponent implements OnInit, AfterViewInit {
  @ViewChild("pageContent") pageContent: ElementRef;
  @ViewChild("backToTopBtn") backToTopBtn: ElementRef;
  sharedInvoices: MatterInvoice[] = [];
  matterInfo: MatterInfo;
  routerState: any;
  matterTransactions: UnityConnectTransaction[] = [];
  matterDocuments: MatterDocument[] = [];
  matterDocuments2: MatterDocument[] = [
    <MatterDocument>{ documentName: "tesx", description: "desc" },
  ];
  defaultcolumnsToDisplay: string[] = [
    "transactionTypeStr",
    "status",
    "transactionDate",
    "client",
  ];
  matterDocumentsColumns: string[] = ["document-name", "document-description"];
  outstandingMatterInvoices: MatterInvoice[] = [];

  selectedTransaction: UnityConnectTransaction;
  connectToken: string;
  logoImageUrl: string;
  sharedDocumentsPackage: SharedDocumentsPackage;
  showInfoExchange = false;
  showAppointment = false;
  isInboxVisible = false;
  isSentItemsVisible = false;
  isUploadedFilesVisible = false;
  messages: DocSharingMessage[] = [];
  showUploadedDocuments = false;
  isBigScreen: boolean = true;

  matterMobileSectionType = MatterMobileSectionTypes.OUTSTANDING;

  outstandingSharedDocumentsTransactions: UnityConnectTransaction[] = [];

  constructor(
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private documentService: DocumentsService,
    private cirfService: CirfService,
    private lockScreenService: LockScreenService,
    private referralService: ReferralService,
    private httpClient: HttpClient,
    private titlecasePipe: TitleCasePipe,
    private navigationService: NavigationService,
    private multipleFileUploadDialogService: MultipleFileUploadDialogService,
    private docSharingMessageService: DocSharingMessageService,
    public datePipe: DatePipe
  ) {
    this.routerState =
      this.router.getCurrentNavigation() &&
      this.router.getCurrentNavigation().extras
        ? this.router.getCurrentNavigation().extras.state
        : undefined;
  }

  ngOnInit(): void {
    this.calculateScreenSize();
    this.matterTransactions = [];
    this.connectToken = sessionStorage.getItem(
      SESSION_STORAGE_KEYS.connectToken
    );
    if (this.routerState && this.routerState.nextState && this.connectToken) {
      this.lockScreenService.lockScreen = true;
      this.documentService
        .getAllTransactionsForCurrentUser()
        .subscribe(
          (unityConnectTransactionsResponse: UnityConnectTransaction[]) => {
            if (Array.isArray(unityConnectTransactionsResponse)) {
              //If it is PARTICIPATING_MATTER, the connectToken should compare to "L + linkId".
              let unityConnectTransaction: UnityConnectTransaction;
              if (this.connectToken.startsWith("L")) {
                unityConnectTransaction = unityConnectTransactionsResponse.find(
                  (item) => "L" + item.linkId == this.connectToken
                );
              } else if (this.connectToken.startsWith("T")) {
                unityConnectTransaction = unityConnectTransactionsResponse.find(
                  (item) =>
                    item.matterInfo &&
                    item.matterInfo.userMatterWorkItems.some(
                      (mw) => mw.inviteGuid == this.connectToken
                    )
                );
              } else {
                unityConnectTransaction = unityConnectTransactionsResponse.find(
                  (item) => item.guid == this.connectToken
                );
              }
              if (unityConnectTransaction) {
                if (unityConnectTransaction.matterId) {
                  let unityConnectTransactions: UnityConnectTransaction[] =
                    unityConnectTransactionsResponse.filter(
                      (msl) => msl.matterId === unityConnectTransaction.matterId
                    );
                  this.matterTransactions.push(...unityConnectTransactions);
                } else {
                  this.matterTransactions.push(unityConnectTransaction);
                }
                this.initMatterSummary();
              }
            }
          }
        )
        .add(() => {
          this.lockScreenService.lockScreen = false;
        });
    } else if (this.routerState) {
      this.matterTransactions.push(...this.routerState.transactions);
      this.initMatterSummary();
    } else {
      const mt: UnityConnectTransaction[] = JSON.parse(
        sessionStorage.getItem(SESSION_STORAGE_KEYS.matterTransactions)
      );
      if (Array.isArray(mt)) {
        this.matterTransactions.push(
          ...mt.map((uct) => {
            return new UnityConnectTransaction(uct);
          })
        );
        this.focusNthRow(0);
      }
    }
  }

  focusNthRow(n: number): void {
    setTimeout(() => {
      jQuery("#info-exchange").find(`tr:eq(${n})`).focus();
    }, 300);
  }

  selectFirstTransaction(): void {
    if (
      this.matterInformationExchangeTransactions &&
      this.matterInformationExchangeTransactions.length
    ) {
      this.selectedTransaction = this.matterInformationExchangeTransactions[0];
    } else {
      this.selectedTransaction =
        this.matterTransactions && this.matterTransactions[0];
    }
  }

  initMatterSummary(): void {
    this.focusNthRow(0);
    sessionStorage.setItem(
      SESSION_STORAGE_KEYS.matterTransactions,
      JSON.stringify(this.matterTransactions)
    );
    if (this.connectToken) {
      if (this.isCirfTransactionType()) {
        this.selectedTransaction = this.matterTransactions.find(
          (transaction) =>
            transaction.transactionType == TransactionTypeValue.cirf
        );
      }
      if (this.isSharedDocumentTransactionType()) {
        this.selectedTransaction = this.matterTransactions.find(
          (transaction) =>
            transaction.transactionType ==
            TransactionTypeValue.sharedDocumentPackage
        );
      }
      if (this.isParticipatingMatterTransactionType()) {
        // Remove connectToken for PARTICIPATING_MATTER for avoid it can't  open cirf, share and refferl when click it from list.
        sessionStorage.removeItem(SESSION_STORAGE_KEYS.connectToken);
        this.selectFirstTransaction();
      }
    } else {
      this.selectFirstTransaction();
    }
    this.setBreadcrumbs();
    if (
      this.selectedTransaction &&
      (this.selectedTransaction.isTransactionUnProccesedReferral() ||
        (this.selectedTransaction.transactionType ===
          TransactionTypeValue.referral &&
          !this.selectedTransaction.referralAddedAsParticipant))
    ) {
      this.navigateToMatterTransaction(this.selectedTransaction);
    } else {
      this.loadMatterAndSelectRow();
    }
  }

  getSelectedTransactionIndex(): number {
    if (
      this.selectedTransaction &&
      this.matterInformationExchangeTransactions &&
      this.matterInformationExchangeTransactions.length
    ) {
      return this.matterInformationExchangeTransactions.findIndex(
        (transaction) => transaction.equals(this.selectedTransaction)
      );
    } else {
      return -1;
    }
  }

  isParticipatingMatterTransactionType(): boolean {
    return this.connectToken && this.connectToken.startsWith("L");
  }

  isCirfTransactionType(): boolean {
    return this.connectToken && this.connectToken.startsWith("C");
  }

  isSharedDocumentTransactionType(): boolean {
    return this.connectToken && this.connectToken.startsWith("D");
  }

  ngAfterViewInit() {
    if (
      !this.selectedTransaction ||
      (this.selectedTransaction &&
        !this.selectedTransaction.isTransactionUnProccesedReferral() &&
        !!this.selectedTransaction.isReferralAddedAsParticipant())
    ) {
      this.loadMatterAndSelectRow();
    }
  }

  loadMatterAndSelectRow(): void {
    if (this.matterTransactions && this.matterTransactions.length) {
      this.loadMatterInfo(this.matterTransactions[0]);
      let selectedTransactionIndex = this.getSelectedTransactionIndex();
      let focusIndex =
        selectedTransactionIndex != -1 ? selectedTransactionIndex : 0;
      this.focusNthRow(focusIndex);
    }
  }

  setBreadcrumbs(): void {
    // Commenting this section just in case they changed their mind
    // if(this.selectedTransaction) {
    //     if (!!this.selectedTransaction.matterAddressOrDescription) {
    //         this.breadcrumbService.set('@MatterSummary', {label: Utils.truncateStringForDisplay(this.selectedTransaction.matterAddressOrDescription, 30, '...')});
    //     }
    //     else if (this.selectedTransaction.isTransactionUnProccesedReferral()) {
    //         // UnProcessed Referral
    //         if (this.selectedTransaction.propertyAddress) {
    //             // First we check whether we have property Address
    //             this.breadcrumbService.set('@MatterSummary', {label: Utils.truncateStringForDisplay(this.selectedTransaction.propertyAddress, 30, '...')});
    //         }
    //         else if (this.selectedTransaction.client) {
    //             // if not we check whether we have clients add
    //             this.breadcrumbService.set('@MatterSummary', {label: Utils.truncateStringForDisplay('Referral of ' + this.selectedTransaction.client, 30, '...')});
    //         }
    //         else if (this.selectedTransaction.lawFirm) {
    //             // if not we check whether we have law firm
    //             this.breadcrumbService.set('@MatterSummary', {label: Utils.truncateStringForDisplay('Referral to ' + this.selectedTransaction.lawFirm, 30, '...')});
    //         }
    //     }
    // }
    this.breadcrumbService.set("@MatterSummary", { label: "File Overview" });
  }

  get columnsToDisplay(): string[] {
    if (
      this.matterTransactions.some(
        (t) => t.transactionType === TransactionTypeValue.referral
      )
    ) {
      return this.defaultcolumnsToDisplay;
    }
    return this.defaultcolumnsToDisplay.filter((col) => col !== "client");
  }

  navigateToMatterTransaction(uct: UnityConnectTransaction) {
    if (!uct) {
      this.notificationService.showNotification(
        Messages.invalidUnityTransactionSelected,
        "error"
      );
    } else if (uct.status === "CANCELLED") {
      this.notificationService.showNotification(
        Messages.cannotEditCancelledCirf,
        "error"
      );
    } else if (uct.status === "EXPIRED") {
      this.notificationService.showNotification(
        Messages.cannotEditExpiredCirf,
        "error"
      );
    } else if (uct.transactionType === TransactionTypeValue.referral) {
      this.router.navigate(["../referral/" + uct.guid], {
        relativeTo: this.route,
        state: {
          isReferralAddedAsParticipant:
            this.referralTransaction.referralAddedAsParticipant,
        },
      });
    } else {
      sessionStorage.setItem(SESSION_STORAGE_KEYS.connectToken, uct?.guid);
      const nextState = this.navigationService.getNextStep(uct?.guid);
      if (
        nextState === "shared-docs" &&
        uct.historyRecord &&
        !uct.historyRecord.packageHistoryItemRead
      ) {
        uct.historyRecord.packageHistoryItemRead = true;
        this.documentService
          .updateSaredDocumentHistoryRecord(uct)
          .subscribe(() => {
            this.router.navigate(["../" + nextState], {
              relativeTo: this.route,
            });
          });
      } else {
        this.router.navigate(["../" + nextState], { relativeTo: this.route });
      }
    }
  }

  get matterInformationExchangeTransactions(): UnityConnectTransaction[] {
    return this.matterTransactions.filter(
      (item) =>
        item.transactionType !== TransactionTypeValue.participatingMatter
    );
  }

  get CirfTransactions(): UnityConnectTransaction[] {
    return this.matterTransactions.filter(
      (item) => item.transactionType == TransactionTypeValue.cirf
    );
  }

  get  SharedDocumentsTransactions(): UnityConnectDocumentsTransaction[] {
    const sharedDocumentTransaction = this.matterTransactions.filter(
      (item) =>
        item.transactionType == TransactionTypeValue.sharedDocumentPackage
    );
    return <UnityConnectDocumentsTransaction[]>sharedDocumentTransaction;
  }

  isFileStatusVisible(): boolean {
    return this.matterTransactions.some(
      (item) =>
        item.transactionType === TransactionTypeValue.participatingMatter
    );
  }

  async loadMatterInfo(uct: UnityConnectTransaction) {
    if (uct) {
      const id = uct.guid;
      let matterInfo: MatterInfo;
      if (uct.isTransactionUnProccesedReferral()) {
        let result = await this.httpClient
          .get<Referral>(connectApi.getReferrals + id)
          .toPromise();
        if (result && !!result["Referral"]) {
          let referral = new Referral(result["Referral"]);
          this.matterInfo = new MatterInfo();
          this.matterInfo.lawFirm = uct.lawFirm;
          this.matterInfo.propertyAddress =
            referral.referralForm.propertyAddress;
          this.matterInfo.lawFirmFullAddress =
            referral.referralForm.receivingSolicitorAddress;
          this.matterInfo.matterDescription = referral.client
            ? "Referral of " + referral.client
            : "";
        }
      } else {
        if (uct?.matterId) {
          matterInfo = await this.cirfService
            .getMatterInfoByMatterId(uct?.matterId + "")
            .pipe(
              map((Response) => {
                const now = new Date();
                for (const matterInvoice of Response.matterInvoices) {
                  const transaction = this.SharedDocumentsTransactions.find(
                    (dt) =>
                      dt.documents.some((x) => x.id == matterInvoice.documentId)
                  );
                  matterInvoice.packageGuid = transaction?.guid;
                  if (
                    matterInvoice.dueDate < now &&
                    matterInvoice.dueDate !== null &&
                    matterInvoice.paymentUrl !== null
                  ) {
                    this.outstandingMatterInvoices.push(matterInvoice);
                  }
                  if (matterInvoice.paymentUrl !== null) {
                    this.sharedInvoices.push(matterInvoice);
                  }
                }
                return Response;
              })
            )
            .toPromise();
          if (!matterInfo.matterTypeReserved) {
            this.loadDocSharingMessages(uct?.matterId);
          }
        }
      }

      if (matterInfo) {
        this.matterInfo = matterInfo;
        this.loadFirmLogo(id, uct.transactionType, uct.matterId);
      }
    }
  }

  async loadDocSharingMessages(matterId: number) {
    const messages: DocSharingMessage[] = await this.docSharingMessageService
      .getDocSharingMessages(matterId)
      .toPromise();
    if (messages) {
      this.messages = [];
      this.matterDocuments = [];
      const mattDocuments: MatterDocument[] = [];
      this.messages.push(
        ..._.orderBy(messages, ["lastUpdatedTimeStamp"], ["asc"])
      );
      this.messages.forEach((message) => {
        message.attachedDocuments.forEach((matDoc) => {
          if (
            !this.matterDocuments.some(
              (existingMatDoc) => existingMatDoc.id === matDoc.id
            )
          ) {
            mattDocuments.push(matDoc);
          }
        });
      });
      this.matterDocuments = mattDocuments;
    }
  }

  loadFirmLogo(
    id: string,
    transactionType: UnityConnectTransactionType,
    matterId: number
  ) {
    if (transactionType === "SHARED_DOCUMENT_PACKAGE") {
      this.loadFirmLogoForSharedDocPackage(id);
    } else if (transactionType === "REFERRAL") {
      this.loadFirmLogoForReferral(id);
    } else if (transactionType === "CIRF") {
      this.loadFirmLogoForCirf(id);
    } else if (matterId) {
      this.loadFirmLogoForParticipatingMatter(matterId);
    }
  }

  loadFirmLogoForParticipatingMatter(matterId: number) {
    if (matterId && this.matterInfo?.logoFirmFileId) {
      this.logoImageUrl = this.documentService.getParticipatingMatterFirmLogo(
        String(matterId),
        this.matterInfo.logoFirmFileId
      );
    }
  }

  loadFirmLogoForSharedDocPackage(id: string) {
    if (id && this.matterInfo?.logoFirmFileId) {
      this.logoImageUrl = this.documentService.getSharedDocPackageLogoFirm(
        id,
        this.matterInfo.logoFirmFileId
      );
    }
  }

  loadFirmLogoForCirf(id: string) {
    if (id && this.matterInfo?.logoFirmFileId) {
      this.logoImageUrl = this.cirfService.getCirfLogoFirm(
        id,
        this.matterInfo.logoFirmFileId
      );
    }
  }

  loadFirmLogoForReferral(id: string) {
    if (id && this.matterInfo?.logoFirmFileId) {
      this.logoImageUrl = this.referralService.getReferralLogoFirm(
        id,
        this.matterInfo.logoFirmFileId
      );
    }
  }

  get matterDescription(): string {
    if (
      this.matterInfo?.projectName &&
      this?.sharedDocumentsPackage?.isUserOtherPartyProjectLawyerOrLawClerk()
    ) {
      if (this.matterInfo?.matterDescription) {
        return (
          this.matterInfo.projectName +
          " - " +
          this.matterInfo?.matterDescription
        );
      } else {
        return this.matterInfo.projectName;
      }
    } else if (this.matterInfo?.isCustomMatter()) {
      return this.matterInfo?.matterDescription;
    } else {
      return this.matterInfo
        ? this.titlecasePipe.transform(this.matterInfo.matterType) +
            " of  " +
            this.matterInfo.propertyAddress.getAddressText(
              true,
              false,
              false,
              false
            )
        : "";
    }
  }

  isZoomMeeting(appointment: MatterEvent): boolean {
    return (
      appointment &&
      appointment.meetingLink &&
      appointment.eventLocation &&
      appointment.eventLocation === "ZOOM"
    );
  }

  isMsTeamsMeeting(appointment: MatterEvent): boolean {
    return (
      appointment &&
      appointment.meetingLink &&
      appointment.eventLocation &&
      appointment.eventLocation === "MS_TEAMS"
    );
  }

  isGoogleMeetMeeting(appointment: MatterEvent): boolean {
    return (
      appointment &&
      appointment.meetingLink &&
      appointment.eventLocation &&
      appointment.eventLocation === "GOOGLE_MEET"
    );
  }

  isVirtualMeeting(appointment: MatterEvent): boolean {
    return (
      this.isZoomMeeting(appointment) ||
      this.isMsTeamsMeeting(appointment) ||
      this.isGoogleMeetMeeting(appointment)
    );
  }

  isSyngrafiiVirtualMeeting(appointment: MatterEvent): boolean {
    return (
      appointment &&
      appointment.isSyngrafiiVirtualSigningRoom() &&
      !!appointment.meetingLink
    );
  }

  getMettingIcon(meetingLocation: string): string {
    switch (meetingLocation) {
      //case 'ZOOM': return 'assets/img/Zoom - Blue.png';
      case "ZOOM":
        return "assets/img/Zoom - Blue.svg";
      case "MS_TEAMS":
        return "assets/img/Microsoft_Teams_48x48.png";
      case "GOOGLE_MEET":
        return "assets/img/Google-Meet.png";
      default:
        return "";
    }
  }
  getMettingIconSize(meetingLocation: string): string {
    switch (meetingLocation) {
      case "ZOOM":
        return "width-70-percent";
      case "MS_TEAMS":
        return "width-40-percent margin-top-minus-10";
      case "GOOGLE_MEET":
        return "width-25-percent margin-top-minus-10 padding-left-5";
      default:
        return "";
    }
  }

  getUserMatterWorkItems(): MatterWorkItem[] {
    return this.matterInfo?.userMatterWorkItems?.length
      ? this.matterInfo.userMatterWorkItems.filter(
          (workItem) => workItem && workItem.name
        )
      : [];
  }

  getOrderUserMatterWorkItems(): MatterWorkItem[] {
    // let responseSorted = _.orderBy(data, ['customPickListItemSequence'], ['asc']);
    let tmp: MatterWorkItem[] = _.orderBy(
      this.getUserMatterWorkItems(),
      ["name"],
      ["asc"]
    );
    return tmp;
  }

  //If multiple invitees have the same email address, this user will receive multiple appointments with the same id in the summary page
  get uniqueAppointments(): MatterEvent[] {
    if (
      this.matterInfo &&
      this.matterInfo.appointments &&
      this.matterInfo.appointments.length
    ) {
      let uniqueAppts = _.uniqBy(this.matterInfo.appointments, "id");
      uniqueAppts.forEach((item) => {
        item.startTime = this.removeZero(item.startTime);
        item.endTime = this.removeZero(item.endTime);
      });
      return _.orderBy(uniqueAppts, ["startDate"], ["desc"]);
    } else {
      return [];
    }
  }

  matterId(): number {
    if (this.matterTransactions && this.matterTransactions.length) {
      return this.matterTransactions[0]?.matterId;
    }
  }

  openSendMessage(message: DocSharingMessage) {
    const params: MultipleFileUploadDialogParams =
      new MultipleFileUploadDialogParams();
    params.matterId = this.matterId();
    if (message) {
      params.message = message;
      params.readOnly = true;
    } else {
      params.readOnly = false;
    }
    this.multipleFileUploadDialogService.openDialog(params).subscribe((res) => {
      if (res) {
        this.loadDocSharingMessages(this.matterId());
      }
    });
  }

  isCirf(): boolean {
    if (this.matterTransactions && this.matterTransactions.length) {
      return this.matterTransactions[0].isMatterCirf();
    }
    return false;
  }

  selectMatterMobileSection(matterMobileSectionType) {
    this.matterMobileSectionType = matterMobileSectionType;
  }

  isSelectedSection(matterMobileSectionType): boolean {
    return this.matterMobileSectionType == matterMobileSectionType;
  }

  isOutstandingIconVisible(): boolean {
    return true;
  }

  isInvoiceIconVisible(): boolean {
    return true;
  }

  isContactUsIconVisible(): boolean {
    return true;
  }

  isTasksIconVisible(): boolean {
    return (
      this.getUserMatterWorkItems().length > 0 ||
      this.CirfTransactions.length > 0
    );
  }

  isReferralIconVisible(): boolean {
    return !!this.referralTransaction;
  }

  isAppointmentIconVisible(): boolean {
    return this.uniqueAppointments && this.uniqueAppointments.length > 0;
  }

  isCorrespondenceIconVisible(): boolean {
    return (
      (this.SharedDocumentsTransactions &&
        this.SharedDocumentsTransactions.length > 0) ||
      (this.messages && this.messages.length > 0) ||
      (this.matterDocuments && this.matterDocuments.length > 0)
    );
  }

  isInitiateMessageIconVisible(): boolean {
    return (
      this.matterInfo &&
      !this.matterInfo.matterTypeReserved &&
      !!this.matterId()
    );
  }

  getNumberOfVisibleItems(): number {
    let number = 0;
    if (this.isOutstandingIconVisible()) {
      number++;
    }
    if (this.isContactUsIconVisible()) {
      number++;
    }
    if (this.isTasksIconVisible()) {
      number++;
    }
    if (this.isAppointmentIconVisible()) {
      number++;
    }
    if (this.isCorrespondenceIconVisible()) {
      number++;
    }
    if (this.isInitiateMessageIconVisible()) {
      number++;
    }
    if (this.isReferralIconVisible()) {
      number++;
    }
    return number;
  }

  getListItemClass(): string {
    let itemClass = "col-2";
    let numberOfItems = this.getNumberOfVisibleItems();
    if (numberOfItems) {
      switch (numberOfItems) {
        case 1:
          return "col-12";
        case 2:
          return "col-6";
        case 3:
          return "col-4";
        case 4:
          return "col-3";
        case 5:
          return "width-20-percent";
        case 6:
          return "col-2";
        case 7:
          return "width-14-percent";
      }
    }
    return itemClass;
  }

  get matterTypeText(): string {
    return this.matterInfo?.matterTypeText;
  }

  get propertyAddressText(): string {
    return this.matterInfo?.propertyAddress?.getAddressText(
      true,
      true,
      false,
      true
    );
  }

  get closingDateText(): string {
    return this.matterInfo?.closingDate
      ? ` ` + this.datePipe.transform(this.matterInfo.closingDate, "mediumDate")
      : "";
  }

  onScrollEvent() {
    Utils.toggleBackToTopBtnVisibility(this.pageContent, this.backToTopBtn);
  }

  backToTop() {
    Utils.backToTop(this.pageContent);
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.calculateScreenSize();
  }

  calculateScreenSize(): void {
    this.isBigScreen = window.outerWidth >= TABLETMIN;
  }

  initiateMessage(): void {
    this.selectMatterMobileSection("CONTACT_US");
    this.openSendMessage(null);
  }

  selectInbox(): void {
    this.isInboxVisible = true;
    this.isUploadedFilesVisible = false;
    this.isSentItemsVisible = false;
    this.selectMatterMobileSection("CORRESPONDENCE");
  }

  selectSentItems(): void {
    this.isInboxVisible = false;
    this.isUploadedFilesVisible = false;
    this.isSentItemsVisible = true;
    this.selectMatterMobileSection("CORRESPONDENCE");
  }

  selectUploadedFiles(): void {
    this.isInboxVisible = false;
    this.isUploadedFilesVisible = true;
    this.isSentItemsVisible = false;
    this.selectMatterMobileSection("CORRESPONDENCE");
  }

  getOutstandingSharedDocumentsTransactions(): UnityConnectTransaction[] {
    //Include Shared Documents if there unopened documents
    return (
      this.SharedDocumentsTransactions &&
      this.SharedDocumentsTransactions.filter(
        (item) => item.hasUnopenedDocuments
      )
    );
  }

  getOutstandingUserMatterWorkItems(): MatterWorkItem[] {
    let matterWorkItems: MatterWorkItem[] = this.getUserMatterWorkItems();
    let outstandingWorkItems: MatterWorkItem[] = [];
    if (Array.isArray(matterWorkItems)) {
      // include all in progress tasks (both due and late) -means the status is assigned
      // include tasks which Due Date is null
      outstandingWorkItems = matterWorkItems.filter(
        (item) => !item.isCompleted()
      );
    }

    return Array.isArray(outstandingWorkItems)
      ? _.orderBy(outstandingWorkItems, ["dueDateNumber"], ["asc"])
      : [];
  }

  get outstandingMatterInformationExchangeTransactions(): UnityConnectTransaction[] {
    // include OUTSTANDING and INPROGRESS
    if (this.CirfTransactions && this.CirfTransactions.length > 0) {
      return this.CirfTransactions.filter(
        (item) => item.status == "OUTSTANDING" || item.status == "INPROGRESS"
      );
    } else {
      return [];
    }
  }

  get referralTransaction(): UnityConnectTransaction {
    return this.matterTransactions.find(
      (item) => item.transactionType === "REFERRAL"
    );
  }

  removeZero(time: string): string {
    if (time && time.startsWith("0")) {
      return time.slice(1);
    } else {
      return time;
    }
  }

  openFile(doc: MatterDocument): void {
    //const parsedUrl = new URL(window.location.href);
    let baseUrl = window.location.origin;
    let api: string = connectApi.downloadAttachedDocument;
    //http://localhost:3000/api/v2/connect/matters/550537384578304/documents/1657/download
    let url =
      baseUrl +
      api
        .replace("{matterId}", "" + this.selectedTransaction?.matterId)
        .replace("{documentId}", "" + doc.id) +
      "?SessionId=" +
      sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId);
    window.open(url, "_blank");
  }
}
